var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullTeamConnectivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.058,
    height: 133.136,
    viewBox: "0 0 133.058 133.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102",
    transform: "translate(-4725.452 -1809.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M433.4,431.08a23.668,23.668,0,0,0-12.245-6.332c-1.511-.293-1.111,1.432-5.5,12.068h-6.049c-4.365-10.583-3.979-12.362-5.5-12.068A23.14,23.14,0,0,0,385.287,443.8l-.983,6.368c-.353,2.286,1.042.626,55.647,1.17a1.016,1.016,0,0,0,1-1.171c-.978-3.807-.169-11.858-7.56-19.087Zm-46.905,18.226.8-5.2a21.077,21.077,0,0,1,16.359-17.193c4.374,10.8,3.953,11.932,5.252,11.932h7.448a1.016,1.016,0,0,0,.949-.654l4.3-11.279a21.6,21.6,0,0,1,10.371,5.617c5.024,4.914,5.864,9.839,6.792,16.774Z",
    transform: "translate(4417.041 1490.734)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M445.589,332.26c0,7.732,5.1,16.722,11.673,16.722s11.673-8.988,11.673-16.729v-.12c-.054-15-23.291-14.809-23.345.128Zm21.315,0c0,6.653-4.3,14.689-9.642,14.689s-9.642-8.036-9.642-14.686c.045-12.326,19.238-12.344,19.282-.123v0Z",
    transform: "translate(4372.405 1566.252)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M162.993,443.8a23.141,23.141,0,0,0-18.821-19.052,1.01,1.01,0,0,0-1.136.637l-4.361,11.433h-6.049c-4.362-10.574-3.978-12.363-5.5-12.068A23.141,23.141,0,0,0,108.309,443.8l-.983,6.368a1.016,1.016,0,0,0,1,1.171h54.643a1.016,1.016,0,0,0,1-1.171c-.018-.1-1-6.473-.985-6.37ZM109.514,449.3c.822-3.146.158-10.286,6.792-16.774a21.608,21.608,0,0,1,10.371-5.617l4.3,11.279a1.015,1.015,0,0,0,.949.654h7.448a1.016,1.016,0,0,0,.949-.654l4.3-11.279a21.075,21.075,0,0,1,16.359,17.193l.8,5.2Z",
    transform: "translate(4618.641 1490.735)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M181,321.03h-1.427a11.188,11.188,0,0,0-11.02,11.271c0,7.732,5.1,16.722,11.673,16.722S191.9,340.034,191.9,332.3v-.123A11.065,11.065,0,0,0,181,321.03Zm-.774,25.961c-5.341,0-9.642-8.036-9.642-14.686a9.152,9.152,0,0,1,8.988-9.243H181a9.029,9.029,0,0,1,8.867,9.119v.12c0,6.653-4.3,14.689-9.642,14.689Z",
    transform: "translate(4574.063 1566.21)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8998",
    "data-name": "Path 8998",
    d: "M242.791,171.387c.579.676-2.586.219,57.212.355,1.72,0,.746-2.183-.012-7.747a23.868,23.868,0,0,0-19.413-19.651c-1.555-.3-1.224,1.71-5.648,12.466h-6.294c-4.6-11.179-4.134-12.761-5.648-12.466a23.869,23.869,0,0,0-19.413,19.65c-.894,6.557-1.318,6.769-.784,7.393Zm2.791-7.083a21.8,21.8,0,0,1,16.95-17.793c4.616,11.426,4.131,12.33,5.4,12.33h7.694c1.3,0,.859-1.083,5.4-12.33,15.191,3.422,16.9,17.692,16.95,17.793l.834,5.406H244.749Z",
    transform: "translate(4520.196 1694.845)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8999",
    "data-name": "Path 8999",
    d: "M317.813,66.013c6.771,0,12.023-9.266,12.023-17.241v-.128c-.056-15.445-23.992-15.249-24.047.132,0,7.971,5.253,17.237,12.024,17.237ZM327.8,48.653v.123c0,6.887-4.456,15.206-9.992,15.206s-9.992-8.318-9.992-15.2c.047-12.773,19.938-12.8,19.983-.128Z",
    transform: "translate(4474.168 1772.85)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9000",
    "data-name": "Path 9000",
    d: "M111.261,176.105h6.208a1.016,1.016,0,0,0,1.016-1.016V146.46h16.438c.124,2.212-.325,3.1.5,3.586a1.017,1.017,0,0,0,1.012.007c12.177-7.084,12.63-6.62,12.63-7.714s-.416-.608-12.63-7.714a1.016,1.016,0,0,0-1.515.885v2.709H111.261a1.016,1.016,0,0,0-1.016,1.016V175.09a1.017,1.017,0,0,0,1.016,1.015Zm25.694-38.854,9.029,5.09-9.029,5.09Zm-24.678,3h22.646v4.177H117.47a1.016,1.016,0,0,0-1.016,1.016v28.629h-4.177Z",
    transform: "translate(4616.507 1701.993)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9001",
    "data-name": "Path 9001",
    d: "M480.232,148.988v24.564c-2.212.124-3.1-.325-3.586.5-.542.925.044.725,6.821,13.124a1.016,1.016,0,0,0,1.77,0c6.784-12.412,7.357-12.209,6.821-13.124a1.013,1.013,0,0,0-.877-.5h-2.709V141.764c0-1.955-1.767-.586-32.806-1.016a1.016,1.016,0,0,0-1.016,1.016v6.208c0,1.947,1.909.6,25.581,1.016Zm4.12,35.624-5.09-9.029h10.18Zm-27.669-41.833h29.758v30.773h-4.177V147.973c0-1.947-1.91-.6-25.581-1.016Z",
    transform: "translate(4365.811 1697.491)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M314.059,371.207V365a1.016,1.016,0,0,0-1.016-1.016H285.317c-.124-2.212.325-3.1-.5-3.586-.951-.558-.952.168-13.124,6.821a1.016,1.016,0,0,0,0,1.77l12.113,6.829a1.016,1.016,0,0,0,1.515-.885v-2.709c27.084-.428,28.741.937,28.741-1.015Zm-2.032-5.192v4.176H285.317v-4.176Zm-28.741,7.178-9.029-5.09,9.029-5.09v10.18Z",
    transform: "translate(4499.365 1537.664)",
    fill: "#5fccf2",
    stroke: "#5fccf2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTeamConnectivity);
export default __webpack_public_path__ + "static/media/fullTeamConnectivity.5bf19278957e8811951a58ee56f47b8f.svg";
export { ForwardRef as ReactComponent };